export const environment = {
	production: true,
	baseUrl: 'https://crm.dynamicwebeurope.com:8080/api',
	isMockEnabled: true, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5'
};
